import { useState } from "react";
import { Input } from "@/components/ui/input";

// Numeric input that keeps the raw typed text while focused and shows a formatted value otherwise.
export const NumCell = ({ value, onChange, digits = 2, testId, className = "", prefix, ...rest }) => {
  const [draft, setDraft] = useState(null);
  const shown = draft ?? (Number.isFinite(+value) ? String(Math.round(+value * 10 ** digits) / 10 ** digits) : "");
  return (
    <div className="relative">
      {prefix && (
        <span className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-gray-400">{prefix}</span>
      )}
      <Input
        type="number"
        inputMode="decimal"
        value={shown}
        onFocus={() => setDraft(shown === "0" ? "" : shown)}
        onBlur={() => setDraft(null)}
        onChange={(e) => {
          setDraft(e.target.value);
          onChange(e.target.value === "" ? 0 : parseFloat(e.target.value) || 0);
        }}
        className={`font-mono h-9 text-sm border-gray-200 ${prefix ? "pl-6" : ""} ${className}`}
        data-testid={testId}
        {...rest}
      />
    </div>
  );
};

export const FieldBlock = ({ label, description, children, testId }) => (
  <div className="p-4 rounded-lg border border-gray-100 bg-gray-50/50" data-testid={testId}>
    <div className="text-sm font-medium text-gray-800">{label}</div>
    <p className="text-xs text-gray-500 mt-1 mb-3 leading-relaxed">{description}</p>
    {children}
  </div>
);
